import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isValidQuery } from '@modules/quantify/utils';
import { Box, Stack } from '@mui/material';
import { useMeasure } from 'react-use';
import { QuantifyReportFeedbackMetric } from './QuantifyReportFeedbackMetric';
import { QuantifyVisualisationTypeToggleButton } from './QuantifyVisualisationTypeToggleButton';

export function QuantifyReportToolbar() {
  const query = useQuantifyStore(({ query }) => query);
  const isTableQueryInProgress = useQuantifyStore(
    ({ visual }) => visual.isTableQueryInProgress,
  );

  const shouldRenderFeedbackMetric =
    !isTableQueryInProgress && isValidQuery(query);

  const [elementRef, { width: elementWidth }] = useMeasure();

  if (query.compareQuery) {
    return null;
  }

  const isSmallSize = elementWidth < 600;

  return (
    <Box ref={elementRef}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={!isSmallSize ? 1.5 : undefined}
        sx={{
          ...(isSmallSize
            ? {
                flexWrap: 'wrap',
                rowGap: 0.5,
                columnGap: 0.5,
              }
            : {}),
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <QuantifyVisualisationTypeToggleButton />
        </Stack>
        {shouldRenderFeedbackMetric && <QuantifyReportFeedbackMetric />}
      </Stack>
    </Box>
  );
}
